import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gettHallPostpage, handleOut } from "@/api/managementCenter/jobManage";
import switchJob from "@/components/management/job/switchJob";
export default {
  name: "rightList",
  components: {
    switchJob: switchJob
  },
  data: function data() {
    return {
      loading: false,
      list: [],
      pageSizes: [20, 30, 50, 100],
      paramSearch: {
        current: 1,
        size: 20
      },
      total: 0,
      postId: ""
    };
  },
  methods: {
    loadListFn: function loadListFn(postId) {
      this.postId = postId;

      if (this.postId) {
        this.getListFn();
      }
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this = this;

      this.list = [];
      this.total = 0;
      this.loading = true;
      gettHallPostpage(_objectSpread(_objectSpread({}, this.paramSearch), {}, {
        postId: this.postId
      })).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.list = data.data.records || [];
          _this.total = data.data.total;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    // 条数
    changeSize: function changeSize(value) {
      this.paramSearch.size = value;
      this.paramSearch.current = 1;
      this.getListFn();
    },
    // 翻页
    changePage: function changePage(value) {
      this.paramSearch.current = value;
      this.getListFn();
    },
    openDetail: function openDetail() {
      this.$emit("openDetail");
    },
    // 删除
    deleteFn: function deleteFn(id) {
      var _this2 = this;

      this.$confirm("是否确定移出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.deleteHttp(id);
      }).catch(function () {
        _this2.$message.info("已取消移出");
      });
    },
    deleteHttp: function deleteHttp(id) {
      var _this3 = this;

      this.loading = true; // 删除接口

      handleOut(id).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$message.success("移出成功!");

          _this3.getListFn();
        } else {
          _this3.$message.warning(data.msg || "移出失败！");
        }
      }).catch(function () {
        _this3.loading = false;

        _this3.$message.error("移出异常!");
      });
    },
    switchJobFn: function switchJobFn(item) {
      this.$refs.switchJob.dialogShow(item);
    },
    saveSuccess: function saveSuccess() {
      this.getListFn();
    }
  }
};